import React from "react";
import styles from "./NewPerksFromBrands.module.scss";
import GridCard from "components/GridCard/GridCard";
import classNames from "classnames";
import Link from "next/link";
import RightArrowGreenCircleIcon from "public/icons/right-arrow-green-circle.svg";

type Props = {
  title: string;
  brands: {
    tickerSymbol: string;
    logo: string;
    name: string;
    perkSummary?: string;
  }[];
  loadingCount?: number;
  viewAllBrandsCard?: boolean;
};

const NewPerksFromBrands = (props: Props) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{props.title}</h3>
      <div className="row">
        {props.loadingCount &&
          props.brands.length === 0 &&
          Array.from({ length: props.loadingCount }).map((_, index) => (
            <div
              className={classNames("col-xl-3 col-6", styles.card)}
              key={`brand-card-empty-${index}`}
            >
              <GridCard title="" />
            </div>
          ))}
        {props.brands.map((brand) => {
          return (
            <div
              className={classNames("col-xl-3 col-6", styles.card)}
              key={`new-brand-perks-${brand.tickerSymbol}`}
            >
              <Link href={`/brand/${brand.tickerSymbol}`}>
                <a>
                  <GridCard
                    title={brand.name}
                    mainImage={brand.logo}
                    tag={brand.perkSummary}
                  />
                </a>
              </Link>
            </div>
          );
        })}
        {props.viewAllBrandsCard && (
          <div className={classNames("col-xl-3 col-6", styles.card)}>
            <div className={styles.allBrandsCard} key={`new-brand-perks-all`}>
              <Link href="/brands/all">
                <a className={styles.brandsWithPerks__viewAllBrands}>
                  <RightArrowGreenCircleIcon />
                  <h5>View all brands with perks</h5>
                </a>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewPerksFromBrands;
